module.exports = {
  toroW2A: (data) => {
    // console.log("w2a data:", data);
    try {
      // eslint-disable-next-line no-undef
      if (W2A_OPEN_CASH) {
        // eslint-disable-next-line no-undef
        W2A_OPEN_CASH.postMessage(data);
      }
    } catch (error) {
      // console.log("w2a error:", error)
    }
  }
}